import React from "react";
import { useNavigate } from "react-router-dom";

import "./ageVerification.scss";

const AgeVerification = ({ onSetAgeVerification }) => {
  const navigate = useNavigate();

  return (
    <div className="age-verification">
      <div className="age-verification__content">
        <h2>Elmúlt már 18 éves?</h2>
        <p>A Honvéd Shop elkötelezett a kulturált italfogyasztás mellett.</p>
        <p>Szeszesitalaink fogyasztását 18 éven aluliak számára nem ajánljuk.</p>
        <div className="button-container">
          <button className="btn btn-primary" onClick={() => onSetAgeVerification(true)}>Igen, elmúltam 18 éves</button>
          <button className="btn btn-outline-secondary" onClick={() => navigate("/nyitolap")}>Nem múltam el 18 éves</button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;
